export class AlgoliaGeneralError extends Error {}
